export default "__VITE_ASSET__0b306b2a__"